import { EventRuntimeEngineServiceInfoEntity } from "@hds-products/event-runtime-entities-common";
import { FrankServiceEntityPersistence } from "@hds/entity-lib";

class EventRuntimeEngineServiceInfoClientEntity extends EventRuntimeEngineServiceInfoEntity {
    constructor(ep, seedData = {}, options = {}) {
        super(ep, seedData, options);
    }
    static createInstance(baseUri, seedData, customHeaderFn) {
        const ep = EventRuntimeEngineServiceInfoClientEntity.createEntityPersistence(baseUri, customHeaderFn);
        return new EventRuntimeEngineServiceInfoClientEntity(ep, seedData);
    }
    static createEntityPersistence(baseUri, customHeaderFn) {
        const ep = new FrankServiceEntityPersistence(baseUri, EventRuntimeEngineServiceInfoClientEntity.prototype._meta.entityName, customHeaderFn);
        return ep;
    }
    /*****************************************************/
    // START OVERRIDDEN PROPERTIES
    /*****************************************************/
    set lastUpdated(newLastUpdated) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set events(newEvents) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set items(newItems) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    /*****************************************************/
    // END OVERRIDDEN PROPERTIES
    // START OVERRIDDEN METHODS
    /*****************************************************/
    create() { throw new Error('METHOD_NOT_ALLOWED'); }
    upsert() { throw new Error('METHOD_NOT_ALLOWED'); }
    update() { throw new Error('METHOD_NOT_ALLOWED'); }
    patch() { throw new Error('METHOD_NOT_ALLOWED'); }
    replace() { throw new Error('METHOD_NOT_ALLOWED'); }
    delete() { throw new Error('METHOD_NOT_ALLOWED'); }
    /*****************************************************/
    // END OVERRIDDEN METHODS
    /*****************************************************/
}

export { EventRuntimeEngineServiceInfoClientEntity };
export default EventRuntimeEngineServiceInfoClientEntity;